import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LanguageProvider } from "@/context/LanguageContext";
import PageTransition from "@/components/PageTransition";
import ScrollProgress from "@/components/ScrollProgress";
import Navigation from "@/components/Navigation";
import HeroSection from "@/components/HeroSection";
import MandateSection from "@/components/MandateSection";
import VisionSection from "@/components/VisionSection";
import PlatformSection from "@/components/PlatformSection";
import GovernanceSection from "@/components/GovernanceSection";
import InquirySection from "@/components/InquirySection";
import Footer from "@/components/Footer";
import BackToTop from "@/components/BackToTop";
import TermsPage from "@/pages/TermsPage";
import PrivacyPage from "@/pages/PrivacyPage";
import RiskPage from "@/pages/RiskPage";
import NotFoundPage from "@/pages/NotFoundPage";
import DantesPage from "@/pages/DantesPage";
import DantesPricingPage from "@/pages/DantesPricingPage";
import DantesSecurityPage from "@/pages/DantesSecurityPage";
import { CinematicEntrance } from "@/components/CinematicEntrance";
import { CustomCursor } from "@/components/CustomCursor";
import { useEffect } from "react";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

const MarqueeStrip = () => {
  const text = "DISTRESSED REAL ESTATE \u00B7 SPECIAL SITUATIONS \u00B7 QU\u00C9BEC \u00B7 EST. 2026 \u00B7 IMMOBILIER EN D\u00C9TRESSE \u00B7 SITUATIONS SP\u00C9CIALES \u00B7 ";
  return (
    <div className="overflow-hidden py-5 bg-[var(--bg-default)]" aria-hidden="true">
      <div className="marquee-text font-sans text-[11px] uppercase tracking-[0.3em]" style={{ color: '#181818' }}>
        {text}{text}
      </div>
    </div>
  );
};

const HomePage = () => (
  <>
    <Navigation />
    <ScrollProgress />
    <main>
      <HeroSection />
      <MandateSection />
      <VisionSection />
      <PlatformSection />
      <MarqueeStrip />
      <GovernanceSection />
      <InquirySection />
    </main>
    <Footer />
    <BackToTop />
  </>
);

const AppRoutes = () => (
  <>
    <ScrollToTop />
    <PageTransition>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/dantes" element={<DantesPage />} />
        <Route path="/dantes/pricing" element={<DantesPricingPage />} />
        <Route path="/dantes/security" element={<DantesSecurityPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/risk" element={<RiskPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </PageTransition>
  </>
);

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <CinematicEntrance>
          <CustomCursor />
          <AppRoutes />
        </CinematicEntrance>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
